import React from 'react'

const Wall = () => <div />

export default Wall
